// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldTreeContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import connect from 'share/enhancers/Izenda.Connect';
import React, { Component, PropTypes } from 'react';
import SearchTextBox from 'share/components/controls/Izenda.SearchTextBox';
import DataTree from '../DataSourceTree/Izenda.DataSourceTree';
import CalculatedField from 'share/components/controls/calculatedField/Izenda.CalculatedField';
import constants from 'logic/data/Izenda.ReportDesignerConstants';

/**
 * Field Data Tree Container component
 */
@connect()
export default class FieldTreeContainer extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  };

  renderTopContent() {
    const {localization} = this.props;
    const handleClickAddCalculatedField = () => {
      this.renderCalculatedField();
    };
    return (
      <div className='header-panel'>
        <a onClick={handleClickAddCalculatedField}
           className='overflow-text u_block'>
          <span className='icon-plus'/>
          {localization.getText('COMMON_LABEL_ADD_CALCULATED_FIELD')}
        </a>
      </div>
    );
  }

  renderSearchBox() {
    const {store} = this.props;
    const onChangeSearchText = e => {
      store.dataTree.filterText = e.target.value;
    };

    return (
      <div className='search-box'>
        <SearchTextBox
          value={store.dataTree.filterText}
          onChange={onChangeSearchText}/>
      </div>
    );
  }

  closeCalculatedPopup(calculatedData) {
    const {store} = this.props;
    calculatedData && store.addCalculatedField(calculatedData);
  }

  renderCalculatedField() {
    const { props } = this;
    const { store } = props;
    const {calculatedStore, masterModel} = store;
    const sourceId = calculatedStore.expressionSelection.getSelectedDataSourceId();

    store.fillCalculatedFieldData(null, null, true);
    props.openPopup(
      CalculatedField, {
        store: calculatedStore,
        onClose: this.closeCalculatedPopup.bind(this),
        expressionConfig: constants.EXPRESSION_SELECTION.MIDDLE_FIELD,
        querySourceId: sourceId,
        isCheckDuplicateWithActualField: true,
        value: {previewRecord: masterModel.previewRecord}
      }
    );
  }

  render() {
    const { uiStore, store } = this.props;

    return (
      <section className='izenda-FieldTreeContainer u_fullHeight u-posRelative u-bgWhite izenda-Middle-section'>
        <div className='izenda-MiddlePanel-search'>
          {this.renderTopContent()}
          {this.renderSearchBox()}
          <hr/>
        </div>
        <DataTree
          className='izenda-MiddlePanel-content'
          store={store}
          useCheckBox={false}
          expandFieldLevel={true}
          uiStore={uiStore}/>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.FieldTreeContainer.js